import camelCase from 'lodash/camelCase';
import { mergeTeamsRoute } from '@atlassian/jira-router-routes-eoc-merge-teams-routes/src/mergeTeamsRoute.tsx';
import { opsSettingsLayout } from '@atlassian/jira-ops-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';

import AsyncGlobalOperationsSidebar from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { mergeTeamsEntryPoint } from '@atlassian/jira-eoc-merge-teams/src/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const mergeTeamsPageEntryPoint = createPageEntryPoint({
	main: mergeTeamsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export const mergeTeamsRouteEntry: Route = createEntry(mergeTeamsRoute, () => ({
	group: 'eoc',
	layout: opsSettingsLayout,

	resources: [
		...getNavigationResources(),
		getConsolidationStateResource(),
		navigationSidebarGlobalResource,
	],
	entryPoint: () => {
		if (!fg('enable_jsm_operation_team_merge')) {
			return notFoundPageEntrypoint;
		}

		return mergeTeamsPageEntryPoint;
	},

	navigation: {
		menuId: MENU_ID.SETTINGS,
		sidebarId: SIDEBAR_ID.OPERATIONS_GENERAL_CONFIGURATION,
		sidebar: AsyncGlobalOperationsSidebar,
	},

	pageId: 'eoc-merge-teams',
	meta: {
		reporting: {
			id: 'eoc.merge-teams',
			packageName: camelCase('eoc-merge-teams'),
			teamName: 'Alexstrasza',
		},
	},
	component: ErrorPagesNotFound,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-eoc-merge-teams-entries/src/mergeTeamsRouteEntry.tsx',
			whichExportToUse: 'mergeTeamsRouteEntry',
		},

		enabled: true,
	},
}));
